module.exports = __webpack_public_path__ + "static/media/55_000012.1cd444d1.jpg";